import React, { useEffect, useState } from "react";
import ZplLabelPrintButton from "./ZplLabelPrintButton";

export default function PreviewLabel({ columnLabels, labelData, rowsData }) {
  /*   All States
   ********************************************* */
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);

  /*   All Functions
   ********************************************* */
  const getColumnValueOfSelectedRow = (column) => {
    if (!column || !labelData) return null;
    let colIndex = columnLabels.findIndex((col) => col === column);

    // Get value of rowIndex from labelData
    let rowValue = labelData[selectedRowIndex][colIndex];
    return rowValue?.value;
  };

  // Update the getMultipleColumnValueOfFirstRow function:
  const getMultipleColumnValueOfFirstRow = (hide, columns) => {
    if (!columns || !labelData) return null;

    let value = "";
    columns?.forEach((item) => {
      // Handle both new object format and old string format
      const columnName = typeof item === "string" ? item : item.name;
      const columnIndex =
        typeof item === "string"
          ? columnLabels.findIndex((col) => col === item)
          : item.index;

      // Get value using index when available
      let columnValue;
      if (
        columnIndex !== undefined &&
        columnIndex >= 0 &&
        labelData[selectedRowIndex]
      ) {
        columnValue = labelData[selectedRowIndex][columnIndex]?.value;
      } else {
        // Fallback to column name search
        columnValue = getColumnValueOfSelectedRow(columnName);
      }

      if (columnValue) {
        const prefix = hide ? "" : `${columnName} : `;
        value = value
          ? `${value}\u00A0\u00A0\u00A0${prefix}${columnValue}`
          : `${prefix}${columnValue}`;
      }
    });

    return value;
  };

  const getSingleRowTypeValue = (row) => {
    let value = "";

    if (row?.rowValues?.customHeader) {
      value = row.rowValues.customHeader;
    }

    const columnValue = getColumnValueOfSelectedRow(row?.rowValues?.column);
    if (columnValue) {
      const prefix = row?.rowValues?.hideHeader
        ? ""
        : `${row?.rowValues?.column} : `;
      value = value
        ? `${value}\u00A0\u00A0\u00A0${prefix}${columnValue}`
        : `${prefix}${columnValue}`;
    }

    return value;
  };

  const getMultipleRowTypeValue = (row) => {
    let value = "";

    if (row?.rowValues?.customHeader) {
      value = row.rowValues.customHeader;
    }

    const multipleValues = getMultipleColumnValueOfFirstRow(
      row?.rowValues?.hideHeader,
      row?.rowValues?.columns
    );

    if (multipleValues) {
      value = value
        ? `${value}\u00A0\u00A0\u00A0${multipleValues}`
        : multipleValues;
    }

    return value;
  };

  const nextLabel = () => {
    if (selectedRowIndex < labelData?.length - 1) {
      setSelectedRowIndex((prev) => prev + 1);
    }
  };

  const previousLabel = () => {
    if (selectedRowIndex > 0) {
      setSelectedRowIndex((prev) => prev - 1);
    }
  };

  /*   All UseEffects
   ********************************************* */

  useEffect(() => {
    if (labelData?.length) {
      setSelectedRowIndex(0);
    }
  }, [labelData]);

  return (
    <div className="px-3 pb-3 py-1">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <h4 className="h4">Preview Label</h4>
        <h5>
          Showing {selectedRowIndex + 1} of {labelData?.length} Rows
        </h5>
        <div className="d-flex align-items-center gap-1">
          <button
            onClick={() => {
              previousLabel();
            }}
            className={"btn btn-success btn-sm  "}
          >
            <i className="mdi mdi-arrow-left-bold my-0"></i>
          </button>
          <button
            onClick={() => {
              nextLabel();
            }}
            className={"btn btn-success btn-sm "}
          >
            <i className="mdi mdi-arrow-right-bold my-0"></i>
          </button>
          {/* <button className="btn btn-info btn-sm">Print Label</button> */}
          <ZplLabelPrintButton
            columnLabels={columnLabels}
            labelData={labelData}
            rowsData={rowsData}
          />
        </div>
      </div>
      <hr className="mt-0" />
      <div>
        {rowsData?.map((row, index) => (
          <div key={row.rowNo} className="row mb-2">
            <h4 className="col-md-1 mb-0 text-center align-items-center d-flex">
              R {row?.rowNo}
            </h4>
            <div className="col-md-11">
              <div
                className="border text-center flex-center px-2"
                style={{ minHeight: 35 }}
              >
                {/* Manual */}
                {row.rowType === "manual" && (
                  <h4 className="my-0 py-0">{row.rowValues?.customHeader}</h4>
                )}
                {/* Single */}
                {row.rowType === "single" && (
                  <h4 className="my-0 py-0">{getSingleRowTypeValue(row)}</h4>
                )}
                {/* Multiple */}
                {row.rowType === "multiple" && (
                  <h4 className="my-0 py-0">{getMultipleRowTypeValue(row)}</h4>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
